import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid, Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, FormControl, InputLabel, Select, FormControlLabel, Checkbox, MenuItem } from '@mui/material';
import { useUser } from '../contexts/UserContext';
import ResultadoModal from '../components/ResultadoModal';
import Swal from 'sweetalert2';
import { ConstructionOutlined } from '@mui/icons-material';
import GestionOrdenTrabajo from '../Cotizaciones/GestionOrdenTrabajo'; // Import GestionOrdenTrabajo component
import { useAccesos } from '../contexts/AccesosContext';

function GestionClientes({ cliente, onClienteGuardado, onRefreshClientesList, onClose }) {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    // Estados para manejar los valores de los inputs
    const [numeroIdentidad, setNumeroIdentidad] = useState('');
    const [nombreCompleto, setNombreCompleto] = useState('');
    const [direccionCompleta, setDireccionCompleta] = useState('');
    const [correoElectronico, setCorreoElectronico] = useState('');
    const [telefono, setTelefono] = useState('');
    const [sexo, setSexo] = useState('');
    const [sexos, setSexos] = useState([]);
    const [fechaNacimiento, setFechaNacimiento] = useState('');
    const [rpr, setRpr] = useState('');
    const [tipoRh, setTipoRh] = useState('');
    const [tiposRh, setTiposRh] = useState([]);
    const [tarjeta, setTarjeta] = useState('');
    const [tarjetas, setTarjetas] = useState([]);
    const [barrioColonia, setBarrioColonia] = useState('');
    const [barrioColonias, setBarrioColonias] = useState([]);
    const [pais, setPais] = useState('');
    const [depto, setDepto] = useState('');
    const [municipio, setMunicipio] = useState('');
    const [paises, setPaises] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [fechaRpr, setFechaRpr] = useState('');
    const [fechaTipoRh, setFechaTipoRh] = useState('');
    const [whatsapp, setWhatsapp] = useState(false);
    const [pasaporte, setPasaporte] = useState('');
    const [usuarioWebapp, setUsuarioWebapp] = useState(false);
    const [poliza, setPoliza] = useState('');
    const [aseguradora, setAseguradora] = useState('');

    const [aseguradoras, setAseguradoras] = useState([]);
    const [polizas, setPolizas] = useState([]);
    const [celular, setCelular] = useState('');
    const [cuentaContable, setCuentaContable] = useState('');
    const [cuentaContables, setCuentaContables] = useState([]);
    const [patologiaBase, setPatologiaBase] = useState('');
    const [estadoCivil, setEstadoCivil] = useState('');
    const [estadoCiviles, setEstadoCiviles] = useState([]);
    const [profesion, setProfesion] = useState('');
    const [profesiones, setProfesiones] = useState([]);
    const [empleador, setEmpleador] = useState('');
    const [contactoEmergencia, setContactoEmergencia] = useState('');
    const [telefonoContacto, setTelefonoContacto] = useState('');
    const [parentesco, setParentesco] = useState('');
    const [parentescos, setParentescos] = useState([]);
    const [etnia, setEtnia] = useState('');
    const [etnias, setEtnias] = useState([]);
    const [raza, setRaza] = useState('');
    const [razas, setRazas] = useState([]);
    const [openTarjetaDialog, setOpenTarjetaDialog] = useState(false);
    const [tarjetaSeleccionada, setTarjetaSeleccionada] = useState(null);
    const [historialTarjetas, setHistorialTarjetas] = useState([]);
    const [numeroTarjeta, setNumeroTarjeta] = useState('');
    const [fechaVencimiento, setFechaVencimiento] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const { user } = useUser();
    const [modificacion, setModificacion] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [apiResult, setApiResult] = useState({ message: '', status: '' });
    const [IngresadoPor, setIngresadoPor] = useState('');
    const [openRNPModal, setOpenRNPModal] = useState(false);
    const [rnpSearch, setRnpSearch] = useState("");
    const [rnpResults, setRnpResults] = useState([]);
    const puedeCrear = tienePermiso('Crear Cliente');
    const puedeEditarCliente = tienePermiso('Editar Cliente');
    const puedeBuscarRNP = tienePermiso('Buscar en RNP');
    const puedeAsignarTarjeta = tienePermiso('Agregar Tarjeta Descuento');
    const puedeImprimirTarjeta = tienePermiso('Imprimir Tarjeta Salud');
    // Add new state for automatic order creation
    const [clienteGuardado, setClienteGuardado] = useState(null);
    const [openOrdenTrabajoModal, setOpenOrdenTrabajoModal] = useState(false);

    // Listener para cerrar el modal de Orden de Trabajo cuando se dispara desde GestionFactura
    useEffect(() => {
        const handleCloseOrdenTrabajoModal = () => {
            setOpenOrdenTrabajoModal(false);
        };

        // Escuchar el evento personalizado
        window.addEventListener('closeOrdenTrabajoModal', handleCloseOrdenTrabajoModal);

        // Limpieza al desmontar
        return () => {
            window.removeEventListener('closeOrdenTrabajoModal', handleCloseOrdenTrabajoModal);
        };
    }, []);

    const handleRnpSearch = async () => {
        try {
            const response = await fetch(`${server}/RnpIdentidades/${rnpSearch}`);
            if (response.ok) {
                const data = await response.json();
                console.log("Respuesta API:", data);
                // Verifica si la respuesta es un arreglo o si está dentro de $values
                let results = [];
                if (Array.isArray(data)) {
                    results = data;
                } else if (data.$values) {
                    results = data.$values;
                } else if (Object.keys(data).length > 0) {
                    results = [data];
                }
                setRnpResults(results);
            } else {
                Swal.fire("Error", "No se encontraron datos en RNP", "error");
            }
        } catch (error) {
            console.error("Error al buscar en RNP:", error);
            Swal.fire("Error", "Error al buscar en RNP", "error");
        }
    };


    const handleCargarCliente = (row) => {
        // Asigna los valores del registro a los campos del formulario
        setNumeroIdentidad(row.identidad);
        setNombreCompleto(row.nombreCompleto);
        setDireccionCompleta(row.direccion);
        setOpenRNPModal(false);
    };


    // Función para obtener la fecha actual en formato ISO sin la 'Z' final
    function obtenerFechaSinHora() {
        const fecha = new Date();
        return fecha.toLocaleDateString('en-CA'); // Formato 'AAAA-MM-DD'
    }

    const fechaFormateada = obtenerFechaSinHora();

    useEffect(() => {
        if (cliente) {
            setNumeroIdentidad(cliente.numeroIdentidad || '');
            setNombreCompleto(cliente.nombreCompleto || '');
            setDireccionCompleta(cliente.direccionCompleta || '');
            setCorreoElectronico(cliente.correoElectronico || '');
            setTelefono(cliente.telefono || '');
            setSexo(cliente.idSexo || '');
            setFechaNacimiento(cliente.fechaNacimiento || '');
            setRpr(cliente.rpr || '');
            setTipoRh(cliente.idTipoRh || '');
            setTarjeta(cliente.idTarjeta || '');
            setPais(cliente.idPais || '');
            setDepto(cliente.idDepartamento || '');
            setMunicipio(cliente.idMunicipio || '');
            setBarrioColonia(cliente.idBarrioColonia || '');
            setFechaRpr(cliente.fechaRpr || '');
            setFechaTipoRh(cliente.fechaTipoRh || '');
            setWhatsapp(cliente.whatsapp || false);
            setPasaporte(cliente.pasaporte || '');
            setUsuarioWebapp(cliente.usuarioWebapp || false);
            setPoliza(cliente.idPoliza || '');
            setCelular(cliente.celular || '');
            setCuentaContable(cliente.idCuentaContable || '');
            setPatologiaBase(cliente.patologiaBase || '');
            setEstadoCivil(cliente.idEstadoCivil || '');
            setProfesion(cliente.idProfesion || '');
            setEmpleador(cliente.empleador || '');
            setContactoEmergencia(cliente.contactoDeEmergencia || '');
            setTelefonoContacto(cliente.telefonoContacto || '');
            setParentesco(cliente.idParentesco || '');
            setEtnia(cliente.idEtnia || '');
            setRaza(cliente.idRaza || '');
            setHistorialTarjetas([]);  // Initialize as empty array - will be populated by fetchHistorialTarjetas
            setNumeroTarjeta('');
            setFechaVencimiento('');
            setModificacion(2);
            setIngresadoPor(cliente.ingresadoPor);
            setAseguradora(cliente.idOrigen);
            // Activa el modo de edición
            setIsEditing(true);

        } else {
            setModificacion(1);
        }
    }, [cliente]);

    useEffect(() => {
        if (isEditing && cliente?.idPoliza && polizas.length > 0) {
            setPoliza(cliente.idPoliza);
        }
    }, [polizas, isEditing, cliente]);

    const handleCancelEdit = () => {
        // Resetea los valores del formulario a su estado inicial
        setNumeroIdentidad('');
        setNombreCompleto('');
        setDireccionCompleta('');
        setCorreoElectronico('');
        setTelefono('');
        setSexo('');
        setFechaNacimiento('');
        setRpr('');
        setTipoRh('');
        setTarjeta('');
        setBarrioColonia('');
        setPais('');
        setDepto('');
        setMunicipio('');
        setFechaRpr('');
        setFechaTipoRh('');
        setWhatsapp(false);
        setPasaporte('');
        setUsuarioWebapp(false);
        setPoliza('');
        setCelular('');
        setCuentaContable('');
        setPatologiaBase('');
        setEstadoCivil('');
        setProfesion('');
        setEmpleador('');
        setContactoEmergencia('');
        setTelefonoContacto('');
        setParentesco('');
        setEtnia('');
        setRaza('');
        setHistorialTarjetas([]);
        setNumeroTarjeta('');
        setFechaVencimiento('');
        setIngresadoPor('');
        setAseguradora('');

        // Cambia el estado de edición a false
        setIsEditing(false);
    };

    useEffect(() => {
        // Fetch tarjetas disponibles
        fetchTarjetas();
    }, []);

    useEffect(() => {
        if (cliente?.idCliente) {
            fetchHistorialTarjetas(cliente.idCliente);
        }
    }, [cliente?.idCliente]);


    // Generar número de tarjeta aleatorio de 12 dígitos con el primer dígito no siendo 0
    const generarNumeroTarjeta = () => {
        const primerDigito = Math.floor(Math.random() * 9) + 1;
        const otrosDigitos = Array.from({ length: 11 }, () => Math.floor(Math.random() * 10)).join('');
        return `${primerDigito}${otrosDigitos}`;
    };

    const handleTarjetaChange = (event, newValue) => {
        setTarjetaSeleccionada(newValue ? newValue.id : null);
        if (newValue) {
            setNumeroTarjeta(generarNumeroTarjeta()); // Generar número de tarjeta al seleccionar tarjeta
        } else {
            setNumeroTarjeta(''); // Limpiar número de tarjeta si no hay tarjeta seleccionada
        }
    };

    // Helper: obtener descripción de tarjeta por id
    const getDescripcionTarjetaById = (id) => {
        const t = tarjetas?.find(x => x.id === id);
        return t?.descripcionTarjeta || '';
    };


    const handleAsignarTarjeta = async () => {
        // Verifica si se ha seleccionado una tarjeta y se ha generado un número de tarjeta
        if (tarjetaSeleccionada && numeroTarjeta && fechaVencimiento) {
            // Verificar que el cliente ya existe (debe tener idCliente)
            if (!cliente?.idCliente) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Cliente no guardado',
                    text: 'Primero debes guardar el cliente antes de asignar tarjetas.',
                });
                return;
            }

            const existeTarjetaVigente = historialTarjetas?.some(t =>
                    esTarjetaVigente(t.fechaVencimiento)
                );

                if (existeTarjetaVigente) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Tarjeta vigente',
                        text: 'El cliente ya tiene una tarjeta de descuento vigente.',
                    });
                    return;
                }

            // Preparar el payload para la API
            const nuevaTarjetaCliente = {
                id: 0,
                idCliente: cliente.idCliente,
                idTarjeta: tarjetaSeleccionada,
                numeroTarjeta: numeroTarjeta,
                fechaEmision: new Date().toISOString().split('T')[0],
                fechaVencimiento: fechaVencimiento,
                ingresadoPor: user ? user.codigoUsuario : 'ADMIN               '
            };

            try {
                // Guardar la tarjeta en la base de datos
                const response = await fetch(`${server}/MgClientesTarjetasDescuentoes`, {
                    method: 'POST',
                    headers: { 
                        'Content-Type': 'application/json',
                        'x-api-key': key
                    },
                    body: JSON.stringify(nuevaTarjetaCliente),
                });

                if (response.ok) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Tarjeta asignada',
                        text: 'La tarjeta se ha guardado exitosamente',
                        showConfirmButton: false,
                        timer: 1500
                    });

                    // Recargar el historial de tarjetas desde la base de datos
                    await fetchHistorialTarjetas(cliente.idCliente);

                    // Limpiar los campos del formulario pero NO cerrar el diálogo
                    setTarjetaSeleccionada(null);
                    setNumeroTarjeta('');
                    setFechaVencimiento('');
                } else {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Error al guardar la tarjeta');
                }
            } catch (error) {
                console.error("Error al guardar tarjeta:", error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.message || 'No se pudo guardar la tarjeta',
                });
            }

        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Campos incompletos',
                text: 'Por favor, selecciona una tarjeta y especifica la fecha de vencimiento.',
            });
        }
    };

    const handleCloseTarjetaDialog = () => {
        setOpenTarjetaDialog(false);
        setTarjetaSeleccionada(null);
    };

    const esTarjetaVigente = (fechaVencimiento) => {
    if (!fechaVencimiento) return false;

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const vencimiento = new Date(fechaVencimiento);
    vencimiento.setHours(0, 0, 0, 0);

    return vencimiento >= hoy;
};


    const handleImprimirTarjeta = async (idTarjetaCliente) => {
        try {
            console.log('Imprimiendo tarjeta con ID:', idTarjetaCliente);
            console.log('Tipo de ID:', typeof idTarjetaCliente);
            
            if (!idTarjetaCliente || idTarjetaCliente === 'undefined') {
                Swal.fire('Error', 'ID de tarjeta no válido', 'error');
                return;
            }
            
            const response = await fetch(`${server}/MgClientesTarjetasDescuentoes/ImprimirTarjetaDescuento/${idTarjetaCliente}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': key,
                },
            });

            if (response.ok) {
                // Obtener el blob del PDF
                const blob = await response.blob();
                
                // Crear una URL temporal para el blob
                const url = window.URL.createObjectURL(blob);
                
                // Abrir el PDF en una nueva pestaña
                window.open(url, '_blank');
                
                // Limpiar la URL temporal después de un breve delay
                setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                }, 1000);
                
                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Tarjeta de descuento generada correctamente',
                    timer: 2000,
                    showConfirmButton: false
                });
            } else {
                throw new Error(`Error del servidor: ${response.status}`);
            }
        } catch (error) {
            console.error('Error al imprimir tarjeta:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo generar la tarjeta de descuento',
            });
        }
    };

    const fetchSexo = async () => {
        try {
            const response = await fetch(`${server}/MgSexoes`);
            const data = await response.json();
            setSexos(data.$values);
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    };
    const fetchRH = async () => {
        try {
            const response = await fetch(`${server}/MgTiposDeRhs`);
            const data = await response.json();
            setTiposRh(data.$values);
        } catch (error) {
            console.error('Error al cargar los tipos RH:', error);
        }
    };
    const fetchTarjetas = async () => {
        try {
            const response = await fetch(`${server}/MgTarjetasDescuentoes`);
            const data = await response.json();
            setTarjetas(data.$values);
        } catch (error) {
            console.error('Error al cargar las tarjetas de descuento:', error);
        }
    };
    const fetchHistorialTarjetas = async (clienteId) => {
        try {
            const response = await fetch(`${server}/MgClientesTarjetasDescuentoes/porCliente/${clienteId}`);
            const data = await response.json();

            console.log('Datos del historial de tarjetas:', data); // Debug

            let HistorialTarjeras = [];

            // Asegurarse de que $values sea un array antes de mapear
            if (data && data.$values) {
                HistorialTarjeras = Array.isArray(data.$values) ? data.$values : [data.$values];
            }

            console.log('HistorialTarjeras procesado:', HistorialTarjeras); // Debug

            // Combinamos los datos de ambas APIs
            const nuevosValores = HistorialTarjeras.map((valorHistorial) => {
                console.log('Procesando tarjeta individual:', valorHistorial); // Debug individual
                
                // Intentar diferentes nombres para el ID
                const id = valorHistorial.id || 
                          valorHistorial.Id || 
                          valorHistorial.ID ||
                          valorHistorial.idClienteTarjeta ||
                          valorHistorial.IdClienteTarjeta;
                
                const descripcionTarjeta = getDescripcionTarjetaById(valorHistorial.idTarjeta);

                // Si no hay descripción de tarjeta o es solo un guion, retornar null para filtrar después
                if (!descripcionTarjeta || descripcionTarjeta.trim() === '-') {
                    return null;
                }

                return {
                    id: id, // ID de la relación cliente-tarjeta (necesario para imprimir)
                    idTarjeta: valorHistorial.idTarjeta,
                    numeroTarjeta: valorHistorial.numeroTarjeta,
                    fechaEmision: valorHistorial.fechaEmision,
                    fechaVencimiento: valorHistorial.fechaVencimiento,
                    descripcionTarjeta: descripcionTarjeta,
                    estado: valorHistorial.estado || 'Vigente'
                };
            }).filter(tarjeta => tarjeta !== null); // Filtrar los elementos null (tarjetas eliminadas)

            console.log('Valores finales para historial:', nuevosValores); // Debug

            // Reemplazar completamente el historial (no agregar)
            setHistorialTarjetas(nuevosValores);
        } catch (error) {
            console.error('Error al cargar el historial de tarjetas:', error);
        }
    };

    const fetchPais = async () => {
        try {
            const response = await fetch(`${server}/MgPaises`);
            const data = await response.json();
            setPaises(data.$values);
        } catch (error) {
            console.error('Error al cargar los paises:', error);
        }
    };
    const fetchCuentasContables = async () => {
        try {
            const response = await fetch(`${server}/CntCuentasContablesDetalles`);
            const data = await response.json();
            setCuentaContables(data.$values);
        } catch (error) {
            console.error('Error al cargar las cuentas contables:', error);
        }
    };
    const fetchEstadosCiviles = async () => {
        try {
            const response = await fetch(`${server}/PlEstadosCiviles`);
            const data = await response.json();
            setEstadoCiviles(data.$values);
        } catch (error) {
            console.error('Error al cargar los estados civiles:', error);
        }
    };
    const fetchProfesiones = async () => {
        try {
            const response = await fetch(`${server}/MgProfesiones`);
            const data = await response.json();
            setProfesiones(data.$values);
        } catch (error) {
            console.error('Error al cargar las profesiones:', error);
        }
    };
    const fetchParantesco = async () => {
        try {
            const response = await fetch(`${server}/MgParentescoes`);
            const data = await response.json();
            setParentescos(data.$values);
        } catch (error) {
            console.error('Error al cargar las parentesco:', error);
        }
    };
    const fetchAseguradoras = async () => {
        try {
            const response = await fetch(`${server}/MgOrigenes`);
            const data = await response.json();
            // Filtrar solo aquellas aseguradoras cuyo campo 'aseguradora' sea true
            const aseguradorasFiltradas = data.$values.filter((item) => item.aseguradora === true);
            setAseguradoras(aseguradorasFiltradas);
        } catch (error) {
            console.error('Error al cargar las aseguradoras:', error);
        }
    };
    const fetchEtnias = async () => {
        try {
            const response = await fetch(`${server}/MgEtnias`);
            const data = await response.json();
            setEtnias(data.$values);
        } catch (error) {
            console.error('Error al cargar las etnias:', error);
        }
    };
    const fetchRazas = async () => {
        try {
            const response = await fetch(`${server}/MgRazas`);
            const data = await response.json();
            setRazas(data.$values);
        } catch (error) {
            console.error('Error al cargar las razas:', error);
        }
    };

    useEffect(() => {
        const fetchDepartamentos = async () => {
            if (pais) {
                try {
                    const response = await fetch(`${server}/MgDepartamentoes/departamentosbypais/${pais}`);
                    const data = await response.json();
                    setDepartamentos(data.$values);
                } catch (error) {
                    console.error('Error al cargar los departamentos:', error);
                }
            } else {
                setDepartamentos([]);
            }
        };
        fetchDepartamentos();
    }, [pais]);

    useEffect(() => {
        const fetchMunicipios = async () => {
            if (depto) {
                try {
                    const response = await fetch(`${server}/MgMunicipios/municipiosbydepartamento/${depto}`);
                    const data = await response.json();
                    setMunicipios(data.$values);
                } catch (error) {
                    console.error('Error al cargar los municipios:', error);
                }
            } else {
                setMunicipios([]);
            }
        };
        fetchMunicipios();
    }, [depto]);

    useEffect(() => {
        const fetchBarrios = async () => {
            if (municipio) {
                try {
                    const response = await fetch(`${server}/MgBarriosColonias/barriosbymunicipio/${municipio}`);
                    const data = await response.json();
                    setBarrioColonias(data.$values);
                } catch (error) {
                    console.error('Error al cargar los barrios:', error);
                }
            } else {
                setBarrioColonias([]);
            }
        };
        fetchBarrios();
    }, [municipio]);


    // Efectos para cargar opciones de combobox desde la API
    useEffect(() => {
        fetchSexo();
        fetchRH();
        fetchCuentasContables();
        fetchEstadosCiviles();
        fetchProfesiones();
        fetchParantesco();
        fetchEtnias();
        fetchRazas();
        fetchPais();
        fetchAseguradoras()
        fetchPolizas();
        // Aquí se deberían llamar las APIs para cargar los valores de los combobox
        // fetch('url_para_obtener_sexos').then(...).then(setSexos);
        // fetch('url_para_obtener_tipos_rh').then(...).then(setTiposRh);
        // etc.
    }, []);

    // Actualiza la función fetchPolizas para que reciba el id de la aseguradora
    const fetchPolizas = async (idAseguradora) => {
        try {
            // Ajusta la URL de acuerdo a tu API. En este ejemplo se usa "byiasiguradora"
            const response = await fetch(`${server}/MgPolizasDeSeguroes/byidorigen/${idAseguradora}`);
            const data = await response.json();
            console.log(data.$values);
            setPolizas(data.$values || []); // Si data.$values existe, se usa, sino se asigna un array vacío
        } catch (error) {
            console.error('Error al cargar las pólizas:', error);
        }
    };

    // Agrega un useEffect que se ejecute cada vez que cambie la aseguradora
    useEffect(() => {
        if (aseguradora) {
            fetchPolizas(aseguradora);
            // Reinicia la selección de póliza si cambia la aseguradora
            setPoliza('');
        } else {
            setPolizas([]);
            setPoliza('');
        }
    }, [aseguradora]);

    const handleSubmit = async (e) => {


        e.preventDefault();
        if (isEditing && !puedeEditarCliente) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Acceso denegado',
                        text: 'No tienes permiso para editar clientes'
                    });
                    return;
                }
        if (!isEditing && !puedeCrear) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Acceso denegado',
                        text: 'No tienes permiso para crear clientes'
                    });
                    return;
                }

        const clienteActualizado = {
            IdCliente: cliente ? cliente.idCliente : 0,
            numeroIdentidad: numeroIdentidad,
            nombreCompleto: nombreCompleto,
            direccionCompleta: direccionCompleta,
            correoElectronico: correoElectronico,
            telefono: telefono,
            idSexo: sexo,
            fechaIngreso: fechaFormateada,
            fechaNacimiento: fechaNacimiento,
            rpr: rpr,
            fechaRpr: fechaRpr || null,
            idTipoRh: tipoRh ? tipoRh : 0,
            fechaTipoRh: fechaTipoRh || null,
            IngresadoPor: !cliente ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
            ModificadoPor: cliente ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
            idBarrioColonia: barrioColonia ? barrioColonia : 0,
            whatsapp: whatsapp,
            pasaporte: pasaporte,
            usuarioWebapp: usuarioWebapp,
            idPoliza: poliza ? poliza : 0,
            celular: celular,
            idCuentaContable: cuentaContable ? cuentaContable : 0,
            patologiaBase: patologiaBase,
            idEstadoCivil: estadoCivil ? estadoCivil : 0,
            idProfesion: profesion ? profesion : 0,
            empleador: empleador,
            contactoDeEmergencia: contactoEmergencia ? contactoEmergencia : '',
            telefonoContacto: telefonoContacto ? telefonoContacto : '',
            idParentesco: parentesco ? parentesco : 0,
            idEtnia: etnia ? etnia : 0,
            idRaza: raza ? raza : 0,
        };
        Object.keys(clienteActualizado).forEach(key => clienteActualizado[key] === undefined && delete clienteActualizado[key]);

        try {
            const response = await fetch(`${server}/MgClientes${cliente ? '/' + cliente.idCliente : ''}`, {
                method: cliente ? 'PUT' : 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(clienteActualizado),
            });

            if (response.ok) {
                // Variable to store the client ID
                let clienteId;
                
                // For POST requests, we expect a response with the new client data including ID
                if (!cliente) { // If creating a new client
                    try {
                        const isJson = response.headers.get('content-type')?.includes('application/json');
                        if (isJson) {
                            const clienteCreado = await response.json();
                            console.log("Cliente creado:", clienteCreado);
                            clienteId = clienteCreado.id || clienteCreado.idCliente;
                        } else {
                            throw new Error('Respuesta sin cuerpo JSON');
                        }
                    } catch (error) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al obtener el ID del cliente',
                            text: error.message || 'Ocurrió un error inesperado',
                        });
                        return; // Exit early if we can't get the client ID
                    }
                } else {
                    // If updating an existing client, use the known ID
                    clienteId = cliente.idCliente;
                }
                
                console.log("ID del cliente:", clienteId);
                
                if (!clienteId) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo obtener el ID del cliente',
                    });
                    return; // Exit if we don't have a client ID
                }

                // Las tarjetas ahora se guardan inmediatamente al hacer clic en "Asignar"
                // No es necesario guardarlas aquí

                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    text: cliente ? 'Cliente actualizado correctamente' : 'Cliente creado correctamente',
                    showConfirmButton: false,
                    timer: 1500
                });
                
                // Refresh the client list in the parent component immediately
                // This ensures that critical changes like RPR and RH type are reflected immediately
                // for accurate health card and blood type card printing
                if (onRefreshClientesList) {
                    onRefreshClientesList();
                }

                // Prepare client data for work order with the correct ID
                const clienteData = {
                    idCliente: clienteId,
                    numeroIdentidad,
                    nombreCompleto,
                    direccionCompleta,
                    correoElectronico,
                    telefono,
                    celular,
                    idSexo: sexo,
                    descripcionSexo: sexos.find(s => s.idSexo === sexo)?.descripcionSexo || '',
                    fechaNacimiento,
                    idPoliza: poliza ? poliza : 0,
                };
                
                // Set the saved client with the correct ID for work order modal
                setClienteGuardado(clienteData);
                
                // Reset the form only after successful save and list refresh
                handleCancelEdit();
                
                // Notify parent component that a client was saved and reset edit mode
                if (onClienteGuardado) onClienteGuardado();
                
                // Open the order dialog for new clients or if requested
                setOpenOrdenTrabajoModal(true);

            }else if (response.status === 409) {
            // Handle conflict response - client already exists
            try {
                const conflictData = await response.json();
                const errorMessage = conflictData.message || 'El cliente ya existe (conflicto)';
                
                Swal.fire({
                    icon: 'error',
                    title: 'Cliente Existente',
                    text: errorMessage,
                });
            } catch (parseError) {
                // Fallback if we can't parse the JSON response
                Swal.fire({
                    icon: 'error',
                    title: 'Cliente Existente',
                    text: 'El cliente ya existe en el sistema',
                });
            }
        } else {
            // Handle other error responses
            let errorMessage = 'Ocurrió un error inesperado';
            try {
                const errorData = await response.json();
                errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : errorMessage);
            } catch (e) {
                console.error("Error parsing error response:", e);
            }
            
            Swal.fire({
                icon: 'error',
                title: `Error al ${cliente ? 'actualizar' : 'crear'} el cliente`,
                text: errorMessage
            });
        }
    } catch (error) {
        Swal.fire({
            icon: 'error',
            title: 'Error al guardar el cliente',
            text: error.message || 'Ocurrió un error inesperado',
        });
    }
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    {/* Campos existentes */}
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Número de Identidad"
                            value={numeroIdentidad}
                            onChange={(e) => setNumeroIdentidad(e.target.value)}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Nombre Completo"
                            value={nombreCompleto}
                            onChange={(e) => setNombreCompleto(e.target.value)}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            size="small"
                            options={paises}
                            getOptionLabel={(option) => option?.nombrePais || ''}
                            value={paises.find((p) => p.idPais === pais) || null}
                            onChange={(event, newValue) => setPais(newValue ? newValue.idPais : '')}
                            renderInput={(params) => <TextField {...params} label="País" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            size="small"
                            options={departamentos}
                            getOptionLabel={(option) => option?.nombreDepartamento || ''}
                            value={departamentos.find((d) => d.idDepartamento === depto) || null}
                            onChange={(event, newValue) => setDepto(newValue ? newValue.idDepartamento : '')}
                            renderInput={(params) => <TextField {...params} label="Departamento" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            size="small"
                            options={municipios}
                            getOptionLabel={(option) => option?.nombreMunicipio || ''}
                            value={municipios.find((m) => m.idMunicipio === municipio) || null}
                            onChange={(event, newValue) => setMunicipio(newValue ? newValue.idMunicipio : '')}
                            renderInput={(params) => <TextField {...params} label="Municipio" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            size="small"
                            options={barrioColonias}
                            getOptionLabel={(option) => option?.nombreBarrioColonia || ''}
                            value={barrioColonias.find((b) => b.idBarrioColonia === barrioColonia) || null}
                            onChange={(event, newValue) => setBarrioColonia(newValue ? newValue.idBarrioColonia : '')}
                            renderInput={(params) => <TextField {...params} label="Barrio/Colonia" fullWidth />}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Dirección Completa"
                            value={direccionCompleta}
                            onChange={(e) => setDireccionCompleta(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Correo Electrónico"
                            value={correoElectronico}
                            onChange={(e) => setCorreoElectronico(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Teléfono"
                            value={telefono}
                            onChange={(e) => setTelefono(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth required size="small">
                            <InputLabel>Sexo</InputLabel>
                            <Select
                                size="small"
                                value={sexo}
                                onChange={(e) => setSexo(e.target.value)}
                                required
                            >
                                {sexos.map((sexo) => (
                                    <MenuItem value={sexo.idSexo}>{sexo.descripcionSexo}</MenuItem>
                                ))}


                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Fecha de Nacimiento"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={fechaNacimiento}
                            onChange={(e) => setFechaNacimiento(e.target.value)}
                            required
                        />
                    </Grid>

                    {/* Campos nuevos */}
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="RPR"
                            value={rpr}
                            onChange={(e) => setRpr(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Tipo RH</InputLabel>
                            <Select
                                size="small"
                                value={tipoRh}
                                onChange={(e) => setTipoRh(e.target.value)}
                            >
                                {tiposRh.map((tiporh) => (
                                    <MenuItem value={tiporh.idTipoRh}>{tiporh.descripcionTipoRh}</MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Button size="small" variant="outlined" color="primary" onClick={() => setOpenTarjetaDialog(true)} disabled={!puedeAsignarTarjeta} title={!puedeAsignarTarjeta ? 'No tienes permiso' : ''}>
                            Asignar Tarjeta de Descuento
                        </Button>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Fecha RPR"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={fechaRpr}
                            onChange={(e) => setFechaRpr(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Fecha Tipo RH"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={fechaTipoRh}
                            onChange={(e) => setFechaTipoRh(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControlLabel
                            size="small"
                            control={
                                <Checkbox
                                    size="small"
                                    checked={whatsapp}
                                    onChange={(e) => setWhatsapp(e.target.checked)}
                                />
                            }
                            label="Tiene WhatsApp"
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Pasaporte"
                            value={pasaporte}
                            onChange={(e) => setPasaporte(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControlLabel
                            size="small"
                            control={
                                <Checkbox
                                    size="small"
                                    checked={usuarioWebapp}
                                    onChange={(e) => setUsuarioWebapp(e.target.checked)}
                                />
                            }
                            label="Usuario WebApp"
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            size="small"
                            options={aseguradoras}
                            getOptionLabel={(option) => option?.descripcion || ''}
                            value={aseguradoras.find((p) => p.idOrigen === aseguradora) || null}
                            onChange={(event, newValue) =>
                                setAseguradora(newValue ? newValue.idOrigen : '')
                            }
                            renderInput={(params) => <TextField {...params} label="Aseguradora" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            size="small"
                            options={polizas}
                            getOptionLabel={(option) => option?.codigo + ' - ' + option?.descripcion || ''}
                            value={polizas.find((p) => p.id === poliza) || null}
                            onChange={(event, newValue) => setPoliza(newValue ? newValue.id : '')}
                            renderInput={(params) => <TextField {...params} label="Póliza" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Celular"
                            value={celular}
                            onChange={(e) => setCelular(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            size="small"
                            options={cuentaContables}
                            getOptionLabel={(option) => option?.codigo + ' ' + option?.descripcion || ''}
                            value={cuentaContables.find((c) => c.id === cuentaContable) || null}
                            onChange={(event, newValue) => setCuentaContable(newValue ? newValue.id : '')}
                            renderInput={(params) => <TextField {...params} label="Cuenta Contable" fullWidth />}
                        />

                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Patología Base"
                            value={patologiaBase}
                            onChange={(e) => setPatologiaBase(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Estado Civil</InputLabel>
                            <Select
                                size="small"
                                value={estadoCivil}
                                onChange={(e) => setEstadoCivil(e.target.value)}
                            >
                                {estadoCiviles.map((estadocivil) => (
                                    <MenuItem value={estadocivil.idEstadoCivil}>{estadocivil.estadoCivil}</MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            size="small"
                            options={profesiones}
                            getOptionLabel={(option) => option?.descripcion || ''}
                            value={profesiones.find((c) => c.id === profesion) || null}
                            required
                            onChange={(event, newValue) => setProfesion(newValue ? newValue.id : '')}
                            renderInput={(params) => <TextField {...params} label="Profesion" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Empleador"
                            value={empleador}
                            onChange={(e) => setEmpleador(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Contacto de Emergencia"
                            value={contactoEmergencia}
                            onChange={(e) => setContactoEmergencia(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Teléfono Contacto"
                            value={telefonoContacto}
                            onChange={(e) => setTelefonoContacto(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Parentesco</InputLabel>
                            <Select
                                size="small"
                                value={parentesco}
                                onChange={(e) => setParentesco(e.target.value)}
                            >
                                {parentescos.map((parentesco) => (
                                    <MenuItem value={parentesco.id}>{parentesco.descripcion}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Etnia</InputLabel>
                            <Select
                                size="small"
                                value={etnia}
                                onChange={(e) => setEtnia(e.target.value)}
                            >
                                {etnias.map((etnia) => (
                                    <MenuItem value={etnia.id}>{etnia.descripcion}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Raza</InputLabel>
                            <Select
                                size="small"
                                value={raza}
                                onChange={(e) => setRaza(e.target.value)}
                            >
                                {razas.map((raza) => (
                                    <MenuItem value={raza.id}>{raza.descripcion}</MenuItem>
                                ))}

                            </Select>

                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            onClick={() => setOpenRNPModal(true)}
                            disabled={isEditing || !puedeBuscarRNP}
                        >
                            RNP
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button size="small" type="submit" variant="contained" color="primary" disabled={isEditing ? !puedeEditarCliente : !puedeCrear}>
                            {isEditing ? 'Actualizar' : 'Crear'} Cliente
                        </Button>
                        {isEditing && (
                            <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                onClick={handleCancelEdit}
                                style={{ marginLeft: '10px' }}
                            >
                                Cancelar Edición
                            </Button>
                        )}
                    </Grid>
                    <Dialog open={openTarjetaDialog} onClose={handleCloseTarjetaDialog} maxWidth="lg" fullWidth>
                        <DialogTitle>Asignar Tarjeta</DialogTitle>
                        <DialogContent>
                            <Autocomplete
                                options={tarjetas}
                                getOptionLabel={(option) => option?.descripcionTarjeta || ''}
                                value={tarjetas.find((t) => t.id === tarjetaSeleccionada) || null}
                                onChange={handleTarjetaChange}
                                // onChange={(event, newValue) => setTarjetaSeleccionada(newValue ? newValue.id : '')}
                                renderInput={(params) => <TextField {...params} label="Seleccionar Tarjeta" fullWidth />}
                            />
                            <TextField
                                fullWidth
                                label="Número de Tarjeta"
                                value={numeroTarjeta}
                                InputProps={{
                                    readOnly: true, // Hacer que este campo sea de solo lectura
                                }}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                label="Fecha de Vencimiento"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={fechaVencimiento}
                                onChange={(e) => setFechaVencimiento(e.target.value)}
                                margin="normal"
                            />
                            <div style={{ marginTop: '20px', marginBottom: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <Button onClick={handleCloseTarjetaDialog} variant="outlined" color="secondary">
                                    Cancelar
                                </Button>
                                <Button onClick={handleAsignarTarjeta} variant="contained" color="primary">
                                    Asignar
                                </Button>
                            </div>
                            <h3>Historial de Tarjetas</h3>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Número de Tarjeta</TableCell>
                                            <TableCell>Tipo de Tarjeta</TableCell>
                                            <TableCell>Fecha de Vencimiento</TableCell>
                                            <TableCell>Estado</TableCell>
                                            <TableCell>Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {historialTarjetas && historialTarjetas.length > 0 ? (
                                            historialTarjetas.map((tarjeta, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{tarjeta.numeroTarjeta}</TableCell>
                                                    <TableCell>{tarjeta.descripcionTarjeta || getDescripcionTarjetaById(tarjeta.idTarjeta) || '-'}</TableCell>
                                                    <TableCell>{tarjeta.fechaVencimiento}</TableCell>
                                                    <TableCell>{tarjeta.estado || 'Vigente'}</TableCell>
                                                    <TableCell style={{ color: esTarjetaVigente(tarjeta.fechaVencimiento) ? 'green' : 'grey', fontWeight: 'bold'}}>{esTarjetaVigente(tarjeta.fechaVencimiento) ? 'VIGENTE' : 'VENCIDA'}</TableCell>
                                                    <TableCell>
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            size="small"
                                                            disabled={!esTarjetaVigente(tarjeta.fechaVencimiento) || !puedeImprimirTarjeta}
                                                            onClick={() => {
                                                                handleImprimirTarjeta(tarjeta.id);
                                                            }}
                                                        >
                                                            Imprimir
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={4} align="center">
                                                    No hay historial de tarjetas.
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </DialogContent>
                    </Dialog>
                    {/* Componente del modal para mostrar el resultado */}
                    <ResultadoModal
                        open={showModal}
                        onClose={() => setShowModal(false)}
                        resultado={apiResult}
                    />
                    <Dialog open={openRNPModal} onClose={() => setOpenRNPModal(false)} maxWidth="md" fullWidth>
                        <DialogTitle>Buscar Cliente en RNP</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={8}>
                                    <TextField
                                        label="Número de Identidad"
                                        value={rnpSearch}
                                        onChange={(e) => setRnpSearch(e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Button variant="contained" onClick={handleRnpSearch}>
                                        Buscar
                                    </Button>
                                </Grid>
                            </Grid>
                            {rnpResults && rnpResults.length > 0 && (
                                <TableContainer component={Paper} style={{ marginTop: 20 }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Identidad</TableCell>
                                                <TableCell>Nombre Completo</TableCell>
                                                <TableCell>Dirección</TableCell>
                                                <TableCell>Fecha de Nacimiento</TableCell>
                                                <TableCell>Sexo</TableCell>
                                                <TableCell>Acción</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rnpResults.map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{row.identidad}</TableCell>
                                                    <TableCell>{row.nombreCompleto}</TableCell>
                                                    <TableCell>{row.direccion}</TableCell>
                                                    <TableCell>{row.fechaNacimiento}</TableCell>
                                                    <TableCell>
                                                        {row.idSexo === 1 ? "Masculino" : row.idSexo === 2 ? "Femenino" : ""}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button variant="contained" onClick={() => handleCargarCliente(row)}>
                                                            Cargar Cliente
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenRNPModal(false)} color="secondary">
                                Cerrar
                            </Button>
                        </DialogActions>
                    </Dialog>                    {/* Dialog for order management - Automatically opened after saving a client */}
                    <Dialog 
                        open={openOrdenTrabajoModal} 
                        onClose={() => setOpenOrdenTrabajoModal(false)} 
                        maxWidth="xl" 
                        fullWidth
                        PaperProps={{
                            style: {
                                minWidth: '95%', // Make dialog take up 95% of screen width
                                maxWidth: '95%'
                            }
                        }}
                        // Permitir cerrar al hacer clic fuera del modal
                        disableEscapeKeyDown={false}
                        disableBackdropClick={false}
                    >
                        <DialogTitle>Orden de Trabajo</DialogTitle>
                        <DialogContent>
                            <GestionOrdenTrabajo
                                cliente={clienteGuardado} // Pasar el cliente guardado a la orden de trabajo
                                onClose={() => setOpenOrdenTrabajoModal(false)}
                            />
                        </DialogContent>
                    </Dialog>
                </Grid>
            </form >

        </>
    );
}

export default GestionClientes;
